import { black, white } from '../consts/variables';

export enum LuminanceEnum {
    dark = 'dark',
    light = 'light',
}

export const getColorLuminance = (color: string): string => {
    const inputColor = getRgbColorObj(color);
    const hsp = Math.sqrt(
        0.299 * (inputColor.r * inputColor.r) +
            0.587 * (inputColor.g * inputColor.g) +
            0.114 * (inputColor.b * inputColor.b),
    );
    if (hsp > 127.5) {
        return LuminanceEnum.light;
    } else {
        return LuminanceEnum.dark;
    }
};

export const getColorWithAlphaChannel = (color: string): string => {
    const inputColor = getRgbColorObj(color);
    const alphaChannel = 0.8;
    return `rgba(${inputColor.r},${inputColor.g},${inputColor.b},${alphaChannel})`;
};

export const getComplementaryColor = (luminance: string): string => {
    if (luminance === LuminanceEnum.dark) {
        return white;
    }
    return black;
};

interface IRGBcolor {
    r: number;
    g: number;
    b: number;
}

export const getRgbFromHex = (color: string): IRGBcolor => {
    const result =
        color.length === 4
            ? /^#?([a-f\d]{1})([a-f\d]{1})([a-f\d]{1})$/i.exec(color)
            : /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(color);
    return {
        r: parseInt(color.length === 4 ? `${result[1]}${result[1]}` : result[1], 16),
        g: parseInt(color.length === 4 ? `${result[2]}${result[2]}` : result[2], 16),
        b: parseInt(color.length === 4 ? `${result[3]}${result[3]}` : result[3], 16),
    };
};

export const getRgbObjectFromRgb = (color: string): IRGBcolor => {
    const colorsArray = color.split('(')[1].split(',');
    return {
        r: parseInt(colorsArray[0], 10),
        g: parseInt(colorsArray[1], 10),
        b: parseInt(colorsArray[2], 10),
    };
};

export const getRgbColorObj = (color: string): IRGBcolor => {
    return color.charAt(0) === '#' ? getRgbFromHex(color) : getRgbObjectFromRgb(color);
};
